"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable camelcase */
var react_1 = __importDefault(require("react"));
var react_sortable_hoc_1 = require("react-sortable-hoc");
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var phrases_1 = __importDefault(require("@src/phrases"));
var ToggleDetailsContainer_1 = __importDefault(require("./ToggleDetailsContainer/ToggleDetailsContainer"));
var styled_components_1 = __importDefault(require("styled-components"));
var hslBuilder_1 = __importDefault(require("@haptik/helpers/build/esm/hslBuilder"));
var hslDisplay_1 = __importDefault(require("@haptik/helpers/build/esm/hslDisplay"));
var const_1 = require("@src/const");
var TaskHeader_1 = __importDefault(require("./TaskHeader"));
var TaskBody_1 = __importDefault(require("./TaskBody"));
var constants_1 = require("../constants");
require("./TaskBox.scss");
var KEYWORDS = phrases_1["default"].getPhrase;
var HSLWrapperStyles = function (props) {
    var theme = props.theme;
    return {
        marginTop: 6,
        marginBottom: 16,
        borderRadius: theme.radii.sm,
        border: "1px solid " + theme.colors.grey.haptik,
        flexDirection: 'column',
        maxWidth: 334,
        alignItems: 'center',
        padding: '22px 0px 0px 0px',
    };
};
var HSLWrapper = styled_components_1["default"](box_1["default"])(HSLWrapperStyles);
var TaskBox = function (_a) {
    var taskBoxData = _a.taskBoxData, handleChange = _a.handleChange, languageCode = _a.languageCode, addNewTask = _a.addNewTask, sortTaskList = _a.sortTaskList, toggleTransferModal = _a.toggleTransferModal, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = react_1["default"].useState(languageCode), language = _c[0], setLanguage = _c[1];
    var _d = react_1["default"].useState(-1), rowOpen = _d[0], setRowOpen = _d[1];
    var BUSINESS_HEADERS = constants_1.TASKBOX_KEYS.BUSINESS_HEADERS, BUSINESS_TASKS = constants_1.TASKBOX_KEYS.BUSINESS_TASKS, BUSINESS_TASK_COMPRESS_MENU = constants_1.TASKBOX_KEYS.BUSINESS_TASK_COMPRESS_MENU, BUSINESS_TASK_WELCOME_MESSAGE_DETAILS = constants_1.TASKBOX_KEYS.BUSINESS_TASK_WELCOME_MESSAGE_DETAILS, TASK_MINIMIZE_ON_LAUNCH = constants_1.TASKBOX_KEYS.TASK_MINIMIZE_ON_LAUNCH;
    var businessTasks = taskBoxData[BUSINESS_TASKS];
    var businessTaskHeaders = taskBoxData[BUSINESS_HEADERS];
    var businessTaskCompressMenu = taskBoxData[BUSINESS_TASK_COMPRESS_MENU] || {};
    var businessTaskWelcomeMessageDetails = taskBoxData[BUSINESS_TASK_WELCOME_MESSAGE_DETAILS] || {};
    var isCompressMenuEnabled = businessTaskCompressMenu.is_compress_menu_enabled, compressMenuValue = businessTaskCompressMenu.compress_menu_value;
    var minimizeTaskBoxOnLaunch = businessTaskCompressMenu[TASK_MINIMIZE_ON_LAUNCH];
    var isWelcomeMessageTimeoutEnabled = businessTaskWelcomeMessageDetails.is_welcome_message_timeout_enabled, welcomeMessageTimeoutValue = businessTaskWelcomeMessageDetails.welcome_message_timeout_value;
    // Close any open rows after switching the language
    react_1["default"].useEffect(function () {
        if (language !== languageCode) {
            setLanguage(languageCode);
            setRowOpen(-1);
        }
    });
    // Load Tasks
    var loadTasks = function () {
        var taskRows = [];
        if (businessTasks[languageCode]) {
            businessTasks[languageCode].forEach(function (item, index) {
                var activeClassName = rowOpen === index ? 'active' : '';
                var taskHeaderProps = {
                    taskId: item.id,
                    taskActive: item.active,
                    taskTitle: item.name,
                    taskIndex: index,
                    handleActiveChange: handleChange,
                    userSays: item.message,
                    imageURL: item.image_url,
                    toggleTransferModal: toggleTransferModal,
                };
                taskRows.push(react_1["default"].createElement(accordion_1["default"].Item.Sortable, { active: rowOpen === index, index: index, key: item.id || "newTask" + index, className: "taskBoxListItem " + activeClassName, onChange: function () { return setRowOpen(rowOpen === index ? -1 : index); }, renderHeader: function (_a) {
                        var ExpandIcon = _a.ExpandIcon, ReorderIcon = _a.ReorderIcon;
                        return (react_1["default"].createElement(TaskHeader_1["default"], __assign({}, taskHeaderProps, { expandIcon: react_1["default"].createElement(ExpandIcon, null), sortableHandle: react_1["default"].createElement(ReorderIcon, null), disabled: disabled })));
                    } },
                    react_1["default"].createElement(TaskBody_1["default"], { taskBodyData: item, taskIndex: index, onChange: handleChange, disabled: disabled })));
            });
        }
        return taskRows;
    };
    // Sort tasks
    var handleSort = function (_a) {
        var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
        var taskList = businessTasks[languageCode];
        var orderedData = react_sortable_hoc_1.arrayMove(taskList, oldIndex, newIndex);
        sortTaskList(languageCode, orderedData);
    };
    var renderHSL = function () {
        var hslProps = {
            value: businessTaskHeaders[languageCode],
            onChange: function (value) {
                handleChange(BUSINESS_HEADERS, value);
            },
            withVariants: false,
            withReplies: true,
        };
        if (!disabled) {
            return react_1["default"].createElement(hslBuilder_1["default"], __assign({ baseUrl: const_1.BASE_URL }, hslProps));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, hslProps));
    };
    return (taskBoxData && (react_1["default"].createElement("div", { className: "taskBox" },
        react_1["default"].createElement("div", { className: "taskBoxTitle" }, "Menu Configuration"),
        react_1["default"].createElement("div", { className: "taskBoxRow" },
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Welcome Message"),
            react_1["default"].createElement(HSLWrapper, null,
                renderHSL(),
                !businessTaskHeaders[languageCode] && (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", marginBottom: "16px", marginLeft: "-130px" },
                    react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold", color: "red.haptik" }, "Message cannot be empty"))))),
        react_1["default"].createElement(ToggleDetailsContainer_1["default"], { handleToggle: function (value) {
                handleChange(BUSINESS_TASK_WELCOME_MESSAGE_DETAILS, {
                    is_welcome_message_timeout_enabled: value,
                    welcome_message_timeout_value: welcomeMessageTimeoutValue,
                });
            }, toggleValue: isWelcomeMessageTimeoutEnabled, SliderValue: welcomeMessageTimeoutValue, sliderMinValue: "1", sliderMaxValue: "24", step: "1", handleSlider: function (e) {
                handleChange(BUSINESS_TASK_WELCOME_MESSAGE_DETAILS, {
                    is_welcome_message_timeout_enabled: isWelcomeMessageTimeoutEnabled,
                    welcome_message_timeout_value: e.target.valueAsNumber,
                });
            }, heading: "Repeat Welcome Message", subHeading: "Show the Welcome Message to the user again when they return after " + welcomeMessageTimeoutValue + " hour" + (welcomeMessageTimeoutValue > 1 ? 's' : '') }),
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0", marginTop: "16px" },
            react_1["default"].createElement(ToggleDetailsContainer_1["default"], { handleToggle: function (value) {
                    handleChange(BUSINESS_TASK_COMPRESS_MENU, {
                        is_compress_menu_enabled: value,
                        compress_menu_value: compressMenuValue,
                    });
                }, toggleValue: isCompressMenuEnabled, SliderValue: compressMenuValue, sliderMinValue: "2", sliderMaxValue: "6", step: "1", handleSlider: function (e) {
                    handleChange(BUSINESS_TASK_COMPRESS_MENU, {
                        is_compress_menu_enabled: isCompressMenuEnabled,
                        compress_menu_value: e.target.valueAsNumber,
                    });
                }, heading: "Compress Menu", subHeading: "Display \"See More\" after " + compressMenuValue + " items." })),
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "0", marginTop: "16px" },
            react_1["default"].createElement(ToggleDetailsContainer_1["default"], { noSlider: true, handleToggle: function (value) {
                    var _a;
                    handleChange(BUSINESS_TASK_COMPRESS_MENU, (_a = {
                            is_compress_menu_enabled: isCompressMenuEnabled,
                            compress_menu_value: compressMenuValue
                        },
                        _a[TASK_MINIMIZE_ON_LAUNCH] = value,
                        _a));
                }, toggleValue: minimizeTaskBoxOnLaunch, heading: "Minimize Menu on Launch", subHeading: "Enable this to keep the menu minimized when the Web-SDK widget first loads. Users can open it manually using the menu button." })),
        react_1["default"].createElement(box_1["default"], { padding: "0", marginTop: "16px", justifyContent: "flex-end" },
            react_1["default"].createElement(button_1["default"], { onClick: addNewTask, type: button_1["default"].TYPES.SECONDARY, disabled: disabled }, "+ Add Menu Options")),
        react_1["default"].createElement("div", { className: "taskBoxList" },
            react_1["default"].createElement("div", { className: "taskBoxListHeader" },
                react_1["default"].createElement("div", { className: "taskBoxListHeaderItem tasks" }, "Menu Option(s)"),
                react_1["default"].createElement("div", { className: "taskBoxListHeaderItem userSays" }, KEYWORDS('USER_MESSAGE.PLURAL.CAPITALIZE')),
                react_1["default"].createElement("div", { className: "taskBoxListHeaderItem taskId" }, "Menu Id")),
            react_1["default"].createElement(accordion_1["default"].Sortable, { useDragHandle: true, lockAxis: "y", helperClass: "sortableElement", className: "taskBoxListItems", onSortEnd: handleSort }, loadTasks())))));
};
exports["default"] = TaskBox;
